export default {"src":"/_next/static/media/task-square.63fbd4ec.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};